import { useContext, useMemo, useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  TextField
} from "@mui/material";
import MUIButton from "../../../Component/UI/MUIButton/MUIButton";
import classes from "./Conversations.module.css";
import { DiscoveryContext } from "../discovery-context";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant";

const ConversationForm = ({ onGenerate, loading }) => {
  const discoveryCtx = useContext(DiscoveryContext);

  const [category, setCategory] = useState(() => discoveryCtx.state.selectedCategory || "");
  const [persona, setPersona] = useState("");

  const personaOptions = useMemo(() => {
    return (discoveryCtx?.persona || [])
      .map((p) =>
        typeof p === "object" && p?.title
          ? { name: p.title, value: p.title }
          : typeof p === "string"
            ? { name: p, value: p }
            : null
      )
      .filter(Boolean);
  }, [discoveryCtx?.persona]);

  useEffect(() => {
    if (persona || personaOptions.length === 0) return;
    setPersona(personaOptions[0].value);
  }, [persona, personaOptions]);


  const isDisabled = useMemo(
    () => !category || !persona,
    [category, persona]
  );

  console.log("categoryValue", discoveryCtx.category)

  return (
    <>
      <Stack spacing={3} sx={{ mt: 2 }}>
        <TextField
          label="Brand"
          value={discoveryCtx?.entity || ""}
          fullWidth
          disabled
        />

        {/* Category */}
        <FormControl fullWidth>
          <InputLabel id="category-label">Category</InputLabel>
          <Select
            labelId="category-label"
            value={category}
            label="Category"
            onChange={(e) => setCategory(e.target.value)}
          >
            <MenuItem value="">
              <em>Select Category</em>
            </MenuItem>
            {(discoveryCtx.category || []).map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Persona */}
        <FormControl fullWidth>
          <InputLabel id="persona-label">Persona</InputLabel>
          <Select
            labelId="persona-label"
            value={persona}
            label="Persona"
            onChange={(e) => setPersona(e.target.value)}
          >
            <MenuItem value="">
              <em>Select Persona</em>
            </MenuItem>
            {personaOptions.map((p) => (
              <MenuItem key={p.value} value={p.value}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <div className={classes.actionRow}>
        <MUIButton
          variant="contained"
          color="primary"
          disabled={isDisabled || loading}
          onClick={() => onGenerate({ category, persona })}
        >
          Get Conversations Data
        </MUIButton>
      </div>
    </>
  );
};

export default ConversationForm;
